<template lang="pug">
  b-modal#url-list-script(title='ポップアップ表示ページ', size="lg" hide-footer @shown="onModalShown")
    ul.list-group
      li.list-group-item.border-0.d-flex.justify-content-between.align-items-center(v-for="url in urls" :key="url.url")
        div.d-flex.w-100
          p.mb-0.flex-grow-1.text-truncate {{ url.url }}
          p.mb-0.ml-3 {{ url.condition }}
</template>

<script>
import Vue from 'vue'
import axios from "../../plugins/axios";

export default {
  data() {
    return {
      urls: []
    }
  },
  methods: {
    async onModalShown() {
      const pop_up_token = this.$store.state.pop_up.token

      const response = await axios.get(`/api/v1/popups/${pop_up_token}/urls`);

      this.urls = response.data.urls
    }
  },
  components: {
  },
  async mounted(){
    await Vue.nextTick()
  },
}
</script>
<style lang="scss" scoped>
</style>
